import { useEffect as e, useLayoutEffect as o } from "react";
const t = typeof window > "u" ? e : o;
export {
  t as u
};
